import { FabButtonContainer } from "./style";

interface FabButtonProps {
    onClick?: () => void;
    icon?: React.ReactNode;
    position?: "bottom-right" | "bottom-left" | "top-right" | "top-left";
    size?: number;
}

export const FabButton: React.FC<FabButtonProps> = ({ 
    onClick, 
    icon, 
    position = "bottom-right",
    size = 56
}) => {
    return (
        <FabButtonContainer 
            onClick={onClick}
            $position={position}
            $size={size}
        >
            {icon || <span>+</span>}
        </FabButtonContainer>
    )
}
